module.exports = __webpack_public_path__ + "img/image_key_pod201.bef634a0.png";